import React from 'react';

import {
  ListItemComp,
  ListItemCompAction,
  ListItemCompContent,
  ListItemCompDescription,
  ListItemCompLeading,
  ListItemCompTitle,
  Switch,
} from '@mesh.ai/rabbit';
import { useDispatch } from 'react-redux';

import { toggleNotificationChannel, toggleNotificationChannelForEmployees } from 'services/admin';
import { showSuccessSnackbar } from 'services/snackbar';

import { PaperWithShadow } from 'uiToolkitV1/Paper';

import { NOTIFICATION_CHANNELS, NOTIFICATION_EVENT_CHANNELS } from './constants/NotificationSettingsConstants';
import type { ChannelDetails } from './types';

type NotificationChannelsProps = {
  isEmployeeNotificationSettings?: boolean;
  channelDetailsArray: ChannelDetails[];
  refreshData: () => void;
};

export const NotificationChannels = ({
  isEmployeeNotificationSettings = false,
  channelDetailsArray,
  refreshData,
}: NotificationChannelsProps) => {
  const dispatch = useDispatch();

  const channelOnToggle = ({ uuid, channelType, enabled }) => {
    if (isEmployeeNotificationSettings) {
      toggleNotificationChannelForEmployees({
        uuid,
        channelType,
        enabled,
        isEmployeeNotificationSettings,
      })
        .then(() => {
          refreshData();
          // @ts-expect-error ts issue
          dispatch(showSuccessSnackbar('Notification settings saved successfully!'));
        })
        .catch((err) => {
          console.error('Error in toggling the channel : ', err);
        });
    } else {
      toggleNotificationChannel({ uuid, channelType, enabled })
        .then(() => {
          refreshData();
        })
        .catch((err) => {
          console.error('Error in toggling the channel : ', err);
        });
    }
  };

  return (
    <PaperWithShadow p={3}>
      {channelDetailsArray.length &&
        channelDetailsArray.map((cd, i) => (
          <ListItemComp
            style={{
              borderBottom: i === channelDetailsArray.length - 1 ? 'none' : '1px solid #F5F7F9',
              height: '60px',
            }}
            key={`${cd.uuid}-${cd.channelType}`}
          >
            <ListItemCompLeading style={{ alignItems: 'flex-start', marginTop: '2px' }}>
              {NOTIFICATION_EVENT_CHANNELS[cd.channelType].icon}
            </ListItemCompLeading>
            <ListItemCompContent>
              <ListItemCompTitle bold={false}>{NOTIFICATION_CHANNELS[cd.channelType].heading}</ListItemCompTitle>
              <ListItemCompDescription>{NOTIFICATION_CHANNELS[cd.channelType].description}</ListItemCompDescription>
            </ListItemCompContent>
            <ListItemCompAction>
              <Switch
                checked={cd.enabled}
                onCheckedChange={(checked) =>
                  channelOnToggle({ uuid: cd.uuid, channelType: cd.channelType, enabled: checked })
                }
              />
            </ListItemCompAction>
          </ListItemComp>
        ))}
    </PaperWithShadow>
  );
};
